import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export const OfflineBanner = () => {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (online) return null;
  return (
    <div data-testid="offline-banner" className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] bg-[#1B263B] text-white text-sm font-semibold px-5 py-2.5 rounded-full shadow-lg flex items-center gap-2">
      <WifiOff className="w-4 h-4 text-amber-400" /> Offline — je bekijkt de laatst opgeslagen versie
    </div>
  );
};
